import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";

const CHIPS = ["Menu digitale", "Recensioni Google", "Prenotazioni", "Instagram", "Card NFC"];

const ForVenues = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="chi-siamo" data-testid="venues-section" ref={ref} className="marble-bg-soft relative overflow-hidden py-28 lg:py-40">
      <div className="mx-auto grid max-w-[1440px] items-center gap-20 px-6 lg:grid-cols-2 lg:px-12">
        <div className="relative">
          <Reveal>
            <Overline className="mb-6">Per i locali</Overline>
            <h2 className="font-display text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
              Il tuo locale merita più<br />di un <span className="gold-text italic">semplice menu.</span>
            </h2>
            <p className="mt-8 max-w-md text-base font-light leading-relaxed text-[#A3A3A3]">
              Recensio unisce tecnologia, design e comunicazione per trasformare ogni punto di contatto con il cliente in un'esperienza più semplice, moderna e professionale.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              {CHIPS.map((c, i) => (
                <motion.span
                  key={c}
                  data-testid={`venues-chip-${c.toLowerCase().replace(/\s+/g, "-")}`}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 + i * 0.1, duration: 0.7 }}
                  className="glass-dark border border-[#C19D60]/25 px-5 py-2.5 text-xs font-light tracking-wide text-[#E5CAA4]"
                >
                  {c}
                </motion.span>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="relative">
          <div className="relative overflow-hidden">
            <motion.img
              src="/assets/restaurant.jpg"
              alt="Ristorante di lusso con atmosfera elegante"
              loading="lazy"
              style={{ y }}
              className="h-[420px] w-full scale-110 object-cover lg:h-[560px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent" />
            <div className="absolute inset-5 border border-[#C19D60]/25" aria-hidden="true" />
            <div className="glass-dark absolute bottom-8 left-8 right-8 flex items-center justify-between border border-[#C19D60]/25 px-6 py-4" data-testid="venues-overlay-card">
              <div>
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#C19D60]">Esperienza del cliente</p>
                <p className="font-display mt-1 text-lg italic text-[#F8F5F0]">Ogni tavolo, un punto di contatto digitale</p>
              </div>
              <img src="/assets/recensio-logo.png" alt="" className="hidden h-7 w-auto sm:block" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ForVenues;
